import React from "react";
import { Modal, Alert as AlertControl } from "react-bootstrap";

function detailRdv(props) {
  const { show, Toggle, analyse } = props;

  return (
    <div>
      <Modal show={show} onHide={Toggle}>
        <Modal.Body>
          <img
            src="https://img.icons8.com/fluent/48/000000/close-window.png"
            style={{ float: "right" }}
            onClick={Toggle}
          />
          <h6
            style={{
              marginTop: "27px",
              marginBottom: "18px",
              textAlign: "center",
            }}
          >
            Détails du rendez-vous
          </h6>
          {analyse.length > 0 ? (
            <table className="table table-striped table-bordered text-center">
              <thead>
                <tr>
                  <th>Préstations</th>
                  <th>Prix (Dh)</th>
                </tr>
              </thead>
              {analyse &&
                analyse.map((item) => {
                  console.log(item);
                  return (
                    <tbody>
                      <tr>
                        <td>{item.designation} </td>
                        <td>{item.price} </td>
                      </tr>
                    </tbody>
                  );
                })}
            </table>
          ) : (
            <AlertControl variant="info">
              Aucune details pour ce rendez-vous
            </AlertControl>
          )}
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default detailRdv;
